import { NgClass } from '@angular/common'
import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog'

export interface YesNoDialogModel {
  title: string
  question: string

  disableCritical?: boolean

  buttonLabel?: {
    no: string
    yes: string
  }
}

/**
 * Ein Dialog der eine Ja/Nein Frage anzeigt
 *
 * @example
 * const dialog = inject(MatDialog)
 * const dialogRef = dialog.open(YesNoDialogComponent, {
 *   data: {
 *     title: 'Frage',
 *     question: 'Bist du sicher?'
 *   }
 * })
 * dialogRef.afterClosed().subscribe(result => {
 *   if (result) {
 *     console.log('Ja')
 *   } else {
 *     console.log('Nein')
 *   }
 * })
 */
@Component({
  imports: [NgClass, MatDialogModule, MatButtonModule],
  templateUrl: './yes-no-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './yes-no-dialog.component.scss',
})
export class YesNoDialogComponent {
  readonly data = inject<YesNoDialogModel>(MAT_DIALOG_DATA)

  readonly buttonLabel = this.data.buttonLabel ?? {
    no: 'Nein',
    yes: 'Ja',
  }
}
